import { animated } from 'react-spring'
import styled from '@emotion/styled'
import { css } from 'emotion'
import { getEmbeddedViewFlag } from 'portal-modules/common/utils/get-embedded-flag'
import getProjectConditions from 'portal-modules/common/utils/get-project-conditions'
const { isRP } = getProjectConditions()
// this gets added to #root to make it push away & blur
// whenever an action modal is opened
export const rootStyle = css`
  filter: blur(5px);
  opacity: 0.5;
  transform: scale(0.9);
`

export const rootReskinStyle = css`
  filter: blur(5px);
  opacity: 0.5;
  transform: scale(0.9);
`

// style to adjust the portal div created by Modal
export const portalStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 5;
`

export const portalReskinStyle = (customZIndex = '5') => css`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${customZIndex};
  @media only screen and (max-width: 768px) {
    margin-top: 48px;
  }
`

export const StyledWrapper = animated(styled('div')`
  width: calc(100% - 48px);
  max-width: ${({ isWideDialog, customMaxWidth, isMediumDialog }) =>
    customMaxWidth
      ? customMaxWidth
      : isWideDialog
        ? '600px'
        : isMediumDialog
          ? '530px'
          : '480px'};
  margin: 24px;
`)

export const StyledModalDiv = styled('div')`
  width: 100%;
  background: ${({ theme }) => theme.backgroundColor.tp_card};
  display: flex;
  flex-direction: column;
  padding-bottom: 24px;
  border-radius: ${({ theme }) => theme.mode.card_border_radius};
  border: 1px solid ${({ theme }) => theme.mode.card_border_color};

  @media only screen and (max-width: 500px) {
    height: ${({ newPaymentMethodFields }) => newPaymentMethodFields && '90vh'};
  }
`

export const StyledTitle = styled('h6')`
  border-bottom: ${({ theme, isTimes }) =>
    isTimes ? 'none' : `1px solid ${theme.gray.light}`};
  color: ${({ theme }) => theme.text.white};
  font-size: ${({ fromFlexModal }) => (fromFlexModal ? '26px' : '18px')};
  font-weight: ${({ fromFlexModal }) => (fromFlexModal ? '700' : '600')};
  font-family: ${({ fromFlexModal }) => fromFlexModal && 'Inter'};
  margin: ${({ isCommunity }) => (isCommunity ? '0 24px' : '0')};
  padding: ${({ isCommunity, isForPlaid }) =>
    isCommunity ? '16px 0' : isForPlaid ? '12px 28px' : '12px 16px'};
`

export const StyledDotSpan = styled('span')`
  color: ${({ theme }) => theme.primary.base};
`

export const StyledContent = styled('div')`
  height: 100%;
  outline: none;
  overflow: auto;
  position: relative;
  max-height: 65vh;
  ${({ noPad }) => !noPad && { padding: `24px 24px 0` }};
  color: ${({ theme }) => getEmbeddedViewFlag() && theme.secondary.base};

  &.liStyle {
    li {
      margin-bottom: 0;
    }
  }

  @media only screen and (max-width: 768px) {
    max-height: ${({ newPaymentMethodFields }) =>
      newPaymentMethodFields ? '90vh' : '50vh'};
    padding: 24px 16px 0;
  }

  @media only screen and (max-width: 350px) {
    max-height: 50vh;
    padding: ${({ oneTapPaySlimCard }) => oneTapPaySlimCard && '24px 10px'};
  }
`

export const StyledFooterContent = styled('div')`
  padding: ${({ isfromRPOneTapPayNewFields }) =>
    isfromRPOneTapPayNewFields ? '0' : '24px 24px 0'};
  display: ${({ isfromRPOneTapPay }) => isfromRPOneTapPay && 'flex'};
  justify-content: ${({ isfromRPOneTapPay }) => isfromRPOneTapPay && 'center'};

  @media only screen and (max-width: 350px) {
    padding: ${({ oneTapPaySlimCard }) => oneTapPaySlimCard && '10px 10px'};
  }
`

export const StyledRpModalTimesDiv = styled('div')`
  top: 10px;
  font-size: 26px;
  position: relative;
  cursor: pointer;
  margin: 0 21px 0 auto;
  color: ${({ theme }) => theme.text.white};
`

export const StyledRpModalHeaderWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid ${({ theme }) => theme.gray.light};
  color: ${({ theme }) => theme.text.white};
`
export const classifiedModalDivStyle = css`
  padding-bottom: 8px;
`

export const classifiedWrapperStyle = css`
  width: 327px;
  @media only screen and (max-width: 374px) {
    width: 87%;
  }
`

export const oneTapPayPlaidWrapperStyle = css`
  width: 500px;
  @media only screen and (max-width: 374px) {
    width: 87%;
  }
`
